import { QRCodeSVG } from 'qrcode.react';

type QrcodeProps = {
  data: string;
  size?: number;
};

export const Qrcode = ({ data, size }: QrcodeProps) => {
  return <QRCodeSVG size={size} value={data} />;
};
